<template>

  <div class="row row-responsive">
    <div class="column column-xs-100 column-sm-100">
      <h4 class="title">Dirección</h4>
        <div class="row row-responsive">
          <div class="column column-sm-100">
            <span class="title">Dirección</span>
            <p class="field">
              {{ addressInfo.street }} {{ addressInfo.external_number }} {{ addressInfo.internal_number }}, {{ addressInfo.neighborhood }}, {{ addressInfo.municipality }}.
            </p>
          </div>
          <div class="column column-sm-25">
            <span class="title">Ciudad</span>
            <p class="field">
              {{ addressInfo.city }}
            </p>
          </div>
          <div class="column column-sm-25">
            <span class="title">Estado</span>
            <p class="field">
              {{ addressInfo.state }}
            </p>
          </div>
          <div class="column column-sm-25">
            <span class="title">Código postal</span>
            <p class="field">
              {{ addressInfo.zip_code }}
            </p>
          </div>
          <div class="column column-sm-25">
            <span class="title">Tipo de vivienda</span>
            <p class="field">
              {{ addressInfo.type }}
            </p>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import httpRequestMixin from '@/mixins/httpRequestMixin'
export default {
  name: 'UserProfileAddress',
  data () {
    return {
      addressInfo: []
    }
  },
  mixins: [httpRequestMixin],
  methods: {
    getUserAddress: async function () {
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/profile/address/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      }
      const response = await this.httpRequest(options)
      if (response && response.status === 200) {
        this.addressInfo = response.data
      }
    }
  },
  created: function () {
    this.getUserAddress()
  }
}

</script>



// WEBPACK FOOTER //
// src/views/userProfile/userProfileResume/UserProfileAddress.vue